import React from 'react';
import {ReportProblemOutlined} from '@material-ui/icons';
import { TranslationsTypes } from '@app/models';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    isError: boolean;
    errorMessage?: string;
    errorCode?: TranslationsTypes;
    className?: string;
}
export const ErrorBlock = ({isError, errorMessage, errorCode, className}: IProps) => {
    const { translation } = useTypedTranslation();
    const errorCodeUpperCase: TranslationsTypes = errorCode ? (errorCode.toUpperCase() as TranslationsTypes) : '';

    return isError ? (
            <div className={`error__block ${className}`} >
                <ReportProblemOutlined className='error__block-icon' color='error'/>
                {errorCodeUpperCase ? translation(errorCodeUpperCase) : errorMessage}
            </div>
        ) : null
    ;
};
